import * as React from "react";
import { useEffect, useRef, useState } from "react";
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  useRedirect
} from "react-admin";
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import QRCode from "react-qr-code";
import { Html5Qrcode } from "html5-qrcode";
import { getAuthData } from "../constant/constant";



const jamPlusSatu = (val) => {
  if (!val) return "-";
  const d = new Date(val.replace(" ", "T"));
  d.setHours(d.getHours() + 1);
  return d.toTimeString().slice(0, 5);
};

export const PresensiPpidList = (props) => {
  const auth = getAuthData();
  const role = auth?.role;

  const username = auth?.username;
  const isPpid = username === "ppid";

  const isRole2 = role === "4";
  const isRole3 = role === "4";
  
  // ✅ Hooks dipanggil di dalam komponen
  const qrRef = useRef(null);
  const redirect = useRedirect();

  // ❌ block selain role 2 & 3
  if (!(isRole2 || isRole3)) {
    return (
      <Typography color="error">
        Tidak punya akses ke halaman ini
      </Typography>
    );
  }

  // ===== tanggal =====
  const now = new Date();
  const todayISO = now.toISOString().slice(0, 10);

  const hariTanggal = now.toLocaleDateString("id-ID", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });


  const startScan = async () => {
    if (qrRef.current) return;

    const qr = new Html5Qrcode("qr-reader");
    qrRef.current = qr;

    try {
      await qr.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 250 },
        (decodedText) => {
          qr.stop().then(() => {
            qrRef.current = null;
            redirect(`/presensi_ppid/create?date=${decodedText}`);
          });
        }
      );
    } catch {
      alert("Gagal membuka kamera");
    }
  };

  return (
    <>
      {/* ===== Title ===== */}
      <Typography variant="h6" sx={{ mt: 2 }}>
        Presensi Hari Ini
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        {hariTanggal}
      </Typography>
{!isPpid && (
  <>
    <Button variant="contained" onClick={startScan} sx={{ mb: 2 }}>
      Mulai Scan
    </Button>
    <div id="qr-reader" style={{ width: "100%", minHeight: 300 }} />
  </>
)}

      {/* ===== QR CODE ===== */}
{isPpid && (
  <div style={{ marginBottom: 20 }}>
    <QRCode value={todayISO} size={180} style={{ maxWidth: 200 }} />
  </div>
)}

      {/* ===== LIST ===== */}
      <List
        {...props}
        resource="presensi_ppid"
        perPage={10}
        sort={{ field: "date_created", order: "DESC" }}
        filter={{ tanggal: todayISO }}
        empty={false}
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="username" label="Username" />
          <TextField source="status" label="Status" />
          <FunctionField
            label="Jam"
            render={(record) => jamPlusSatu(record.date_created)}
          />
        </Datagrid>
      </List>
    </>
  );
};